import { BackofficeUser, RoleInfo } from '../types';
import { apiRequest } from './api-client';

export async function fetchUsers(accessToken: string): Promise<BackofficeUser[]> {
  const result = await apiRequest<BackofficeUser[]>('/backoffice/users', accessToken);
  return result || [];
}

export async function fetchRoles(accessToken: string): Promise<RoleInfo[]> {
  const result = await apiRequest<RoleInfo[]>('/backoffice/users/roles', accessToken);
  return result || [];
}

export async function updateUserRoles(userId: string, roles: string[], accessToken: string): Promise<void> {
  await apiRequest(`/backoffice/users/${userId}/roles`, accessToken, {
    method: 'PATCH',
    body: JSON.stringify({ roles }),
  });
}

export async function resetUserPassword(userId: string, newPassword: string, accessToken: string): Promise<void> {
  await apiRequest(`/backoffice/users/${userId}/password`, accessToken, {
    method: 'PATCH',
    body: JSON.stringify({ password: newPassword }),
  });
}

export async function toggleUserStatus(userId: string, accessToken: string): Promise<void> {
  await apiRequest(`/backoffice/users/${userId}/status`, accessToken, { method: 'PATCH' });
}

export async function deleteUser(userId: string, accessToken: string): Promise<void> {
  await apiRequest(`/backoffice/users/${userId}`, accessToken, { method: 'DELETE' });
}
